import Tooltip from '@material-ui/core/Tooltip/Tooltip';
import MyCollapse from 'components/Collapse';
import { MyTableHeader } from 'components/MyTable';
import moment from 'moment';
import React from 'react';
import MyTable from 'v2/components/Shared/MyTable';
import MyTableBody from 'v2/components/Shared/MyTable/MyTableBody';
import MyTableCol from 'v2/components/Shared/MyTable/MyTableCol';
import MyTableRow from 'v2/components/Shared/MyTable/MyTableRow';

import type { ShoppingDelivery } from 'v2/interfaces/shopping';

import useStyle from '../styles';

const headers = [
  { title: '', ordering: false },
  { title: 'Emissão', ordering: false },
  { title: 'Pag.', ordering: false },
  { title: 'Valor', numeric: true, ordering: false },
];
const InvoiceDetails = ({ delivery }: { delivery: ShoppingDelivery }) => {
  const classes = useStyle();
  return (
    <MyCollapse title={`Dados da fatura (${delivery.invoice_id})`} arrow>
      <MyTable responsive={false}>
        <MyTableHeader index={headers} />

        <MyTableBody>
          <MyTableRow>
            <MyTableCol screenSizes={{ xs: 1, sm: 1 }}>
              <Tooltip title={delivery.payment_status.name} placement='top'>
                <div className={`${classes.tableStatus} ${delivery.payment_status.alias}`} />
              </Tooltip>
            </MyTableCol>
            <MyTableCol screenSizes={{ xs: 4, sm: 4 }}>{delivery.created_at ? moment(delivery.created_at).format('DD/MM/YYYY') : '-'}</MyTableCol>
            <MyTableCol screenSizes={{ xs: 4, sm: 4 }}>{delivery.received_at ? moment(delivery.received_at).format('DD/MM/YYYY') : '-'}</MyTableCol>
            <MyTableCol numeric screenSizes={{ xs: 3, sm: 3 }}>
              {delivery.total_value.toLocaleString('pt-BR', { style: 'currency', currency: delivery.currency_code })}
            </MyTableCol>
          </MyTableRow>
        </MyTableBody>
      </MyTable>
    </MyCollapse>
  );
};

export default InvoiceDetails;
